<div
  #input
  class="formfield"
  [class.not-empty]="notEmpty$ | async"
  [class.has-pre]="hasPre"
  [class.has-post]="hasPost && !noPostSpacing"
  [class.no-label]="noLabel"
  [class.small-no-label]="smallNoLabel || verySmallNoLabel"
  [class.hide]="hidden"
  [class.bottom-flat]="bottomFlat"
  [class.top-flat]="topFlat"
  [class.left-flat]="leftFlat"
  [class.right-flat]="rightFlat"
  [class.very-small-no-label]="verySmallNoLabel"
  [class.no-label-extra-spacing]="noLabelExtraSpacing"
  [class.rounded]="rounded"
  [class.block-transitions]="blockTransitions"
  [class.big]="big"
  [class.huge]="huge"
  [class.bigish]="bigish"
  [class.no-pre-spacing]="noPreSpacing"
  [class.centered-post]="centeredBigIcon"
  [class.no-transitions]="noTransitions"
>
  <ng-content select="[fake-input]"></ng-content>
  <ng-content select="input"></ng-content>
  <ng-content select="select"></ng-content>
  <ng-content select="textarea"></ng-content>
  <div class="after">
    <div class="inner-shadow"></div>
    <ng-content select="label"></ng-content>
    <div class="outline"></div>
    @if (control && !noError) {
      <app-input-field-error [control]="control" [rounded]="rounded"> </app-input-field-error>
    }
    @if (preTemplate) {
      <div class="pre-template">
        <ng-container [ngTemplateOutlet]="preTemplate"></ng-container>
      </div>
    }
    @if (postTemplate && !loading) {
      <div class="post-template">
        <ng-container [ngTemplateOutlet]="postTemplate"></ng-container>
      </div>
    }
    @if (loading) {
      <div class="post-template loading">
        <app-loading-indicator size="small" class="small"></app-loading-indicator>
      </div>
    }
  </div>
</div>
